import "./styles/CalBookingEmbed.css";

function CalBookingEmbed({ bookingUrl, title }) {
  if (!bookingUrl) {
    return (
      <section className="surface-card booking-placeholder-card">
        <span className="eyebrow">Cal.com pending</span>
        <h2>Add your booking URL</h2>
        <p>
          Set <strong>REACT_APP_CAL_COM_BOOKING_URL</strong> in your environment file and this page will render the live Cal.com embed.
        </p>
      </section>
    );
  }

  return (
    <section className="booking-embed-shell">
      <iframe
        className="booking-embed-frame"
        src={bookingUrl}
        title={title}
        loading="lazy"
        allow="camera; microphone; fullscreen"
        allowFullScreen
      />
    </section>
  );
}

export default CalBookingEmbed;
